import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import moment from "moment";
import React, { Component } from 'react';
import { SingleDatePicker } from "react-dates";
import { FormattedDate, defineMessages, injectIntl } from "react-intl";
import ImageGallery from "../../common/image/gallery.component.jsx";
import FileGalleryContentInput from "../../template/sections/content/file-gallery/input.component.jsx";
import ImageGalleryContentInput from "../../template/sections/content/image-gallery/input.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
import Document from "../document/document.component.jsx";
import Icon from "../icon/icon.component.jsx";

const messages = defineMessages({
    "project.form.edit.custom_fields.type_single_choice_choose_label": {
        id: 'project.form.edit.custom_fields.type_single_choice_choose_label',
        defaultMessage: 'Choose',
    },
})

class CustomFieldValue extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            value: this.props.value || '',
            editable: this.props.editable || false,
            definitionId: this.props.definitionId || '',
            elementId: this.props.elementId || '',
            element: this.props.element || 'projects',
            fieldType: '',
            name: '',
            metadata: [],
            val: this.props.value || '',
            isLoading: false,
            success: false,
            acceptedFileType: [],
            files: [],
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        const defaultCallback = () => { }
        this.onChange = this.props.onChange || defaultCallback
        this.handleFileFormChange = this.handleFileFormChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value || '',
            elementId: nextProps.elementId || '',
            editable: nextProps.editable || false,
            val: nextProps.value || '',
            definitionId: nextProps.definitionId || '',
        })
        this.loadDefinition(nextProps.definitionId)
    }

    loadDefinition(definitionId) {
        AppContext.getApiClient().get('/custom-field-definitions/' + definitionId).then(d => {
            this.setState({
                fieldType: d.attributes.fieldType,
                name: d.attributes.name,
                metadata: d.attributes.metadata,
                acceptedFileType: d.attributes.acceptedFileType || '',
            })
        })
    }

    componentDidMount() {
        this.loadDefinition(this.state.definitionId)
    }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event?.preventDefault()
        this.setState({
            isLoading: true,
        })
        AppContext.getApiClient().patch('/' + this.state.element + '/' + this.state.elementId, {
            customFieldValues: {
                [this.state.definitionId]: this.state.val,
            },
        }).then((r) => {
            this.setState({
                isLoading: false,
            })
            if (r.error) {
                return
            }
            const value = r.attributes.customFieldValues[this.state.definitionId]
            this.setState({
                value,
                editMode: false,
                success: !r.error,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1500)
            })
            this.onChange(value)
        })
    }

    handleFormChange(event) {
        this.setState({
            val: event.target.value
        })
    }

    handleFileFormChange(value) {
        let documentsId = ''
        if (value.fileIds?.length > 0) {
            documentsId = JSON.stringify(value);
        } 

        this.setState({
            val: documentsId,
        }, this.changeValue)
    }

    renderInput() {
        switch (this.state.fieldType) {
            case 'text':
                return <input
                    value={this.state.val}
                    onChange={this.handleFormChange}
                    id={this.state.definitionId}
                    type="text"
                    className="form-control"
                    placeholder={this.state.name}
                />
            case 'multi-line-text':
                return <textarea
                    value={this.state.val}
                    onChange={this.handleFormChange}
                    id={this.state.definitionId}
                    rows="5"
                    className="form-control"
                    placeholder={this.state.name}
                />
            case 'single-choice':
                return <select
                    value={this.state.val}
                    onChange={this.handleFormChange}
                    id={this.state.definitionId}
                    className="form-control"
                >
                    <option value="">
                        {this.props.intl.formatMessage(messages['project.form.edit.custom_fields.type_single_choice_choose_label'])}
                    </option>
                    {this.state.metadata && Array.isArray(this.state.metadata) ? this.state.metadata.map((value, index) => {
                        return <option value={value} key={index}>
                            {value}
                        </option>
                    }) : null}
                </select>
            case 'date':
                moment.locale(AppContext.getUserLoggedIn().attributes.language)
                return <SingleDatePicker
                    small
                    block
                    showClearDate={true}
                    displayFormat="LL"
                    focused={this.state.focused}
                    isOutsideRange={() => false}
                    onDateChange={(date) => {
                        this.setState({
                            val: date ? date.toDate() : ''
                        }, this.changeValue)
                    }}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    date={this.state.val ? moment(this.state.val) : ''}
                    numberOfMonths={1}
                    id={this.state.definitionId}
                />
            case 'image':
                let parsedJson = this.state.val ? JSON.parse(this.state.val) : ''
                const imageIds = parsedJson ? parsedJson.imageIds : []
                const imagesPerRow = parsedJson ? parsedJson.imagesPerRow : ''
                return <ImageGalleryContentInput
                    hideLabels={true}
                    imageIds={imageIds}
                    onChange={(value) => {
                        const imageIds = value.imageIds.length > 0 ? JSON.stringify(value) : ''
                        this.setState({
                            val: imageIds,
                            imagesPerRow: value.imagesPerRow
                        }, this.changeValue)
                    }} 
                    imagesPerRow={imagesPerRow}
                />
            case 'file':
                let parsedFileJson = this.state.val ? JSON.parse(this.state.val) : ''
                let parsedFileIds = parsedFileJson ? parsedFileJson.fileIds : []
                return <FileGalleryContentInput
                    onChange={(value) => {this.handleFileFormChange(value)}}
                    fileTypes={this.state.acceptedFileType}
                    hideLabels={true}
                    fileIds={parsedFileIds}
                    />
        }
        return null
    }

    render() {
        let value = <span>{this.state.value}</span>
        if (this.state.fieldType === 'date' && this.state.value) {
            value = <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(this.state.value)}
            />
        }
        if (this.state.fieldType === 'multi-line-text' && this.state.value) {
            value = this.state.value.split('\n').map((v, i) => <p key={i} className={'m-0'}>{v}</p>)
        }

        if (this.state.fieldType === 'image' && this.state.value) {
            let parsedJson = this.state.val ? JSON.parse(this.state.val) : ''
            const imageIds = parsedJson ? parsedJson.imageIds : []
            value = <ImageGallery imageIds={imageIds} size={'very-small'} disabled={false} />
        }

        if (this.state.fieldType === 'file' && this.state.value) {
            let parsedJson = this.state.val ? JSON.parse(this.state.val) : ''
            const fileArray = parsedJson ? parsedJson.fileIds : []
            value = fileArray?.map((documentId) => (
                <Document documentId={documentId} />
            ))
        }

        const icon = !this.state.success ? <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
            <Icon value={'check'} className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />
        if (this.state.editable) {
            let link = this.state.fieldType !== 'image' ? <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {value} {icon}
            </a> : <span> {value} <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {icon}
            </a> </span>
            value = <span>
                {link}
                <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')} style={{ width: '450px', top: 'auto', zIndex: '9999' }}>
                    <div className="w-100 m-0">
                        {this.renderInput()}
                    </div>
                    <div className="w-100 m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={this.save}
                            isLoading={this.state.isLoading}
                        >
                            <Icon value={"save"} />
                        </ActionButton>
                    </div>
                </div>
            </span>
        }

        return value
    }

}

export default injectIntl(CustomFieldValue)





// WEBPACK FOOTER //
// ./src/common/custom-field/value.component.jsx